<div class="row">
  <div class="col-12">
    <h2 class="ml-3">{{ editorType === 'edit' ?
      ('CONFIG.one-time-fee.edit-fee' | translate) :
      ('CONFIG.one-time-fee.add-fee' | translate) }}</h2>
  </div>
</div>

<div *ngIf="isLoading" class="row">
  <div class="col-12 pt-5 text-center">
    <mat-spinner class="m-0 m-auto"></mat-spinner>
  </div>
</div>

<div class="row" *ngIf="!isLoading">
  <div class="col-12">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="card shadow mb-5">
        <div class="card-body">
          <div class="row">
            <!-- Name -->
            <app-input type="text" formControlName="name_en" appearance="standard" [fullWidth]="true" class="col-6"
                       [label]="'CONFIG.one-time-fee.editor.form.fee_name' | translate">
            </app-input>
          </div>
          <div class="row pt-5">
            <div class="col-md-4">
              <button mat-raised-button color="primary" type="submit">
                {{ this.editorType === 'edit' ?
                ('CONFIG.one-time-fee.edit-fee' | translate) :
                ('CONFIG.one-time-fee.add-fee' | translate) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
